// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"ImpactPostsListRecordLoader_placeholder__3MqBD"};